// extracted by mini-css-extract-plugin
export var container = "Testimonial-module--container--3tYkB";
export var copy = "Testimonial-module--copy--U96s5";
export var attribution = "Testimonial-module--attribution--qErxM";
export var logo = "Testimonial-module--logo--2olOq";